/*
 * @Author: bbqin
 * @Date: 2019-12-18 13:51:00
 * @LastEditTime: 2023-01-10 20:04:22
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。r
 * @FilePath: \Platform_Front\src\platform\FastExtend\const.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

// 扩展开发的关键字  旧版最外层目录名称以及window上扩展方法对象字面量名称
export const name = 'NCCExtend';

// 弹窗页面
export const isPageModal = true;

// 空方法
export const emptyFunction = function () {
};

// 全局的客开禁用性参数
export const enable = window.FrontExtendEnable || window.NCCExtendEnable || true;

// 存放客开配置文件json的最外层目录名称
export const releaseConfigFileName = 'front_extend_config';

// 模块的缓存名称  用于处理全局方法  ajax  router
export const moduleCacheName = '_front_extend_cache_data';

// 存在全局的
export const freeExtendCacheName = 'free_extend_json';
// 模块里额外的方法存入对象中的位置
export const areaConfigDefaultName = '__default_events';
// 缓存被组织的对象
export const preventEvent = '__prevent_events';
// defaultLayer
export const defaultLayer = '_DEFAULT';
